import { getDefaultOrganization } from '@upright/common/iam/organizations/common';
import { isTeamUser } from '@upright/common/utils';
import { useGetOrganization, useMyOrganizationsQuery } from '@upright/ui/api/iam/organizations/hooks';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import {
  showCompanyDashBoard,
  showInvestorHomeView,
  showSelfSignupCompanyDashboard,
  useFrontPageConfig,
} from '@upright/ui/views/home-views/front-page-config';
import { useOrganizationHasCreateCompaniesPermission } from '@upright/ui/views/home-views/custom-companies-view/hooks/use-organization-has-create-companies-permission';
import styled from 'styled-components';
import { MenuTitleSmall } from '../../shared-menus';
import { CompanyBlock } from './company-block';
import { SelfSignupCompanyBlock } from './company-block/self-signup-company-block';
import { InvestorBlock } from './investor-block';
import { SavedItemsBlock } from './saved-items-block';
import { ScreenerBlock } from './screener-block';

export const LoggedInBlock = () => {
  const user = useGetLoggedInUser();
  const isTeam = isTeamUser(user);
  const getOrganizationsQuery = useMyOrganizationsQuery();
  const organization = getDefaultOrganization(getOrganizationsQuery.data?.organizations, isTeam);
  const getOrganizationDataQuery = useGetOrganization(organization?.id);
  const company = getOrganizationDataQuery.data?.company;

  const { hasPermission: orgHasCreateCompaniesPermission } = useOrganizationHasCreateCompaniesPermission(
    organization?.id,
  );
  const canSeeCustomCompanies = isTeam || orgHasCreateCompaniesPermission;

  const frontPageConfig = useFrontPageConfig();
  const clientType = frontPageConfig.clientType;
  const frontPage = frontPageConfig.frontPage;

  return (
    <Root>
      {clientType === 'non-affiliated' && <MenuTitleSmall>{user?.username}</MenuTitleSmall>}
      {showInvestorHomeView(clientType) && (
        <InvestorBlock clientType={clientType} frontPage={frontPage} organizationName={organization?.name} />
      )}
      {showCompanyDashBoard(clientType) && (
        <CompanyBlock
          company={company}
          user={user}
          clientType={clientType}
          frontPage={frontPage}
          organizationName={organization?.name}
        />
      )}
      {showSelfSignupCompanyDashboard(clientType) && <SelfSignupCompanyBlock user={user} />}
      <ScreenerBlock />
      <SavedItemsBlock canSeeCustomCompanies={canSeeCustomCompanies} />
    </Root>
  );
};

const Root = styled.div``;
